import { useCallback, useEffect } from "react";
import { useCustomerManagementStore } from "./store";
import { useAuthUser } from "./useAuthUser";
import Cookies from "js-cookie";

const metaBrowserPixelKey = "_fbp";
const metaClickCookie = "_fbc";
const metaClickIdentifier = "fbclid";

export const useMetaAnalytics = () => {
  const { isAuthenticated } = useAuthUser();
  const {
    customerManagement: { monitorMetaClientsStatus },
    monitorMetaClients,
    clearMonitorMetaClientsStatus,
  } = useCustomerManagementStore();

  const getMetaBrowserPixelId = useCallback(() => {
    return Cookies.get(metaBrowserPixelKey);
  }, []);

  const getMetaClickId = useCallback(() => {
    let fbc = Cookies.get(metaClickCookie);
    if (!fbc) {
      const params = new URLSearchParams(window.location.search);
      const fbclid = params.get(metaClickIdentifier);
      if (fbclid) {
        fbc = `fb.1.${Math.floor(Date.now() / 1000)}.${fbclid}`;
      }
    }
    return fbc;
  }, []);

  useEffect(() => {
    if (monitorMetaClientsStatus === "success") {
      clearMonitorMetaClientsStatus();
    }
  }, [clearMonitorMetaClientsStatus, monitorMetaClientsStatus]);

  useEffect(() => {
    if (isAuthenticated && process.env.REACT_APP_IS_PRODUCTION === "true") {
      monitorMetaClients({
        browserPixel: getMetaBrowserPixelId(),
        clickId: getMetaClickId(),
      });
    }
  }, [
    getMetaBrowserPixelId,
    getMetaClickId,
    isAuthenticated,
    monitorMetaClients,
  ]);

  return;
};
